import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_AUCTIONS
    SET_SEARCH_FLAG
    AUCTION_REQUEST
    AUCTION_RESPONSE
    SET_AUCTION_TYPE
`,
    {
        prefix: 'auctions/'
    }
);
